import { WidgetBlockToViewBlockHoC, WidgetBlockWrapper } from '../../state-management';
import IWidgetBlock from '../types/IWidgetBlock';
import defaultState from './defaultState';
import ImageFeed from './ImageFeed';
import reducer from './reducer';
import { ImageFeedConfigBlockState, ImageFeedState } from './types';

const WidgetBlock: IWidgetBlock<ImageFeedConfigBlockState, ImageFeedState> = {
    label: 'Image Feed',
    type: 'imageFeed',
    mimeTypes: ['image/png', 'image/jpeg', 'image/gif'],
    defaultState,
    reducer,
    widgetBlock: WidgetBlockWrapper(ImageFeed),
    render: WidgetBlockToViewBlockHoC(reducer, ImageFeed),
    widgetComponent: ImageFeed,
};

export default WidgetBlock;
